// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 913 ? "default" : chunkId) + "." + {"14":"d2995a61","913":"7274e375"}[chunkId] + ".css";
};